import React from 'react';
import {CircularProgress, Stack} from "@mui/joy";
import CardContent from "@mui/joy/CardContent";
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";

// components
import BaseApi from "../../utils/BaseApi";
import CommunicationCard from "../Cards/CommunicationCard";
import CommunicationCreate from "./CommunicationCreate";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";


class CommunicationsCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            communications: null,
            permissions: {
                destroyPermission: 0,
                updatePermission: 0,
                callPermission: 0,
            },
        };
    }

    async componentDidMount() {
        await this.retrieveCommunications();
        await this.retrievePermissions();
    }

    async retrievePermissions() {
        let destroyPermission = await retrievePermission(
            'CommunicationViewSet',
            'destroy',
            this.context.subscriberObject
        );
        let updatePermission = await retrievePermission(
            'CommunicationViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        let callPermission = await retrievePermission(
            'SunsimCallViewSet',
            'list',
            this.context.subscriberObject
        );
        this.setState(
            {
                permissions:{
                    destroyPermission: destroyPermission,
                    updatePermission: updatePermission,
                    callPermission: callPermission,
                }
            }
        );
    }

    async retrieveCommunications() {
        const url = `communication/`;
        const params = {
            related_app: this.props.related_app,
            related_app_id: this.props.related_app_id,
            page_size: 10000,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        await this.setState(
            {
                communications: response.data.results
            }
        );
    }

    render() {
        if (!this.state.communications){
            return (<CircularProgress/>)
        }
        return(
            <Card
                variant={'plain'}
                size={'sm'}
            >
                <CardContent>
                    <Stack
                        spacing={1}
                    >
                        <Typography
                            level={'h4'}
                        >
                            Способы связи
                        </Typography>
                        {
                            this.state.communications.length === 0 ?
                                <Typography
                                    level={'body-md'}
                                >
                                    Список пуст
                                </Typography> :
                                null
                        }
                        {
                            this.state.communications.map(each => {
                                return(
                                    <CommunicationCard
                                        communication={each}
                                        permissions={this.state.permissions}
                                        callBack={this.retrieveCommunications.bind(this)}
                                        showCalls={true}
                                    />
                                )
                            })
                        }
                        <CommunicationCreate
                            related_app={this.props.related_app}
                            related_app_id={this.props.related_app_id}
                            callBack={this.retrieveCommunications.bind(this)}
                        />
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default CommunicationsCard